import { render, staticRenderFns } from "./ResultDetailsCard.vue?vue&type=template&id=3ec3e5da&scoped=true&"
import script from "./ResultDetailsCard.vue?vue&type=script&lang=js&"
export * from "./ResultDetailsCard.vue?vue&type=script&lang=js&"
import style0 from "./ResultDetailsCard.vue?vue&type=style&index=0&id=3ec3e5da&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ec3e5da",
  null
  
)

export default component.exports